module.exports = __webpack_public_path__ + "img/job_examine09.9c5678b6.png";